import request from '@/utils/request'
import host from '@/api/base/host'
import { decryptAES_H5, encryptAES_H5 } from '@/utils'

// 订单模块
const address = host.path('dev', { dev: 'v2/user/myinfo/address' }) // :xhl
const address1 = host.path('dev', { dev: 'v1/user/myinfo/address' }) // :xhl
const common = host.path('dev', { dev: 'v1/common' }) // :xhl

export function getRegions(data) {
  return request({
    url: common('region/list'),
    method: 'post',
    data
  })
}

export default {
  async list(option) {
    const data = await request({
      url: address('h5/list/' + (option || 'all')), // all | default
      method: 'post'
    })
    if (Array.isArray(data)) {
      data.forEach(item => {
        try {
          item.contactName = decryptAES_H5(item.contactName)
        } catch (e) {}
        try {
          item.contactNo = decryptAES_H5(item.contactNo)
        } catch (e) {}
        try {
          item.addressDetail = decryptAES_H5(item.addressDetail)
        } catch (e) {}
      })
    } else if (data) {
      try {
        data.contactName = decryptAES_H5(data.contactName)
      } catch (e) {}
      try {
        data.contactNo = decryptAES_H5(data.contactNo)
      } catch (e) {}
      try {
        data.addressDetail = decryptAES_H5(data.addressDetail)
      } catch (e) {}
    }
    return data
  },
  save(data) {
    return request({
      url: address('h5/' + (data.id ? 'modify' : 'add')),
      method: 'post',
      data: {
        ...data,
        contactName: encryptAES_H5(data.contactName),
        contactNo: encryptAES_H5(data.contactNo),
        addressDetail: encryptAES_H5(data.addressDetail)
      }
    })
  },
  del(data) {
    return request({
      url: address1('del'),
      method: 'post',
      data: {
        addressId: data.id
      }
    })
  },
  mark(data) {
    return request({
      url: address1('mark'),
      method: 'post',
      data: {
        addressId: data.id
      }
    })
  },
  async detail(data) {
    const item = await request({
      url: address('h5/detail'),
      method: 'post',
      data: {
        addressId: data.id
      }
    })
    if (item) {
      try {
        item.contactName = decryptAES_H5(item.contactName)
      } catch (e) {}
      try {
        item.contactNo = decryptAES_H5(item.contactNo)
      } catch (e) {}
      try {
        item.addressDetail = decryptAES_H5(item.addressDetail)
      } catch (e) {}
    }
    return item
  }
}
